export const ldAinShams = {
  '@type': 'EducationalOrganization',
  name: 'Ain Shams University Faculty of Medicine',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Cairo',
    addressCountry: 'Egypt',
  },
  sameAs:
    'https://en.wikipedia.org/wiki/Ain_Shams_University_Faculty_of_Medicine',
  url: 'http://med.asu.edu.eg/',
}

export const ldGMC = {
  '@type': 'Organization',
  name: 'General Medical Council',
  url: 'https://www.gmc-uk.org/',
  sameAs: 'https://en.wikipedia.org/wiki/General_Medical_Council',
}

export const ldRCOA = {
  '@type': 'Organization',
  name: 'Royal College of Anaesthesiologists',
  url: 'https://www.rcoa.ac.uk/',
  sameAs: 'https://en.wikipedia.org/wiki/Royal_College_of_Anaesthetists',
}

export const ldMFT = {
  '@type': 'MedicalOrganization',
  name: 'University of Manchester NHS Foundation Trust',
  url: 'https://mft.nhs.uk/',
  sameAs: 'https://mft.nhs.uk/',
}
